import type { CalculationState } from '../..';
import { isCalculationTacticResultUnavailable } from '../../actions';
import type { LvShortCircuitSummary } from './lowVoltage/LvShortCircuitSummary';
import type { MvShortCircuitSummary } from './mediumVoltage/MvShortCircuitSummary';
import { getShortCircuitSummary } from './summary';

export type ShortCircuitSummary = MvShortCircuitSummary | LvShortCircuitSummary;

export const shortCircuitSummary = (
  state: CalculationState
): CalculationState['shortCircuitSummary'] => {
  if (state.evaluationRules.type === 'UNAVAILABLE') {
    return { type: 'NO_SUMMARY_AVAILABLE' };
  }
  if (
    state.calculationTactic.current !== 'LOADED' ||
    (state.calculationTactic.current === 'LOADED' &&
      state.calculationTactic.value.status !== 'Completed')
  )
    return { type: 'NO_SUMMARY_AVAILABLE' };
  if (
    state.resultsBrowsingMode.matches('BROWSING_SUMMARY') &&
    state.calculationTactic.current === 'LOADED' &&
    state.calculationTactic.value.status === 'Completed'
  ) {
    const calculationTactic = state.calculationTactic.value;
    if (isCalculationTacticResultUnavailable(calculationTactic))
      return { type: 'NO_SUMMARY_AVAILABLE' };

    const voltagelevel = calculationTactic?.calculationSetResult.voltageLevel;

    return {
      type: 'SUMMARY_AVAILABLE',
      summary: getShortCircuitSummary(
        calculationTactic,
        state.evaluationRules.rules,
        voltagelevel
      )
    };
  }
  return { type: 'NO_SUMMARY_AVAILABLE' };
};
